import { render, staticRenderFns } from "./SurfContentEmpty.vue?vue&type=template&id=498ec69c&scoped=true"
import script from "./SurfContentEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfContentEmpty.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfContentEmpty.vue?vue&type=style&index=0&id=498ec69c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ec69c",
  null
  
)

export default component.exports